const root = '/encryption';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  encryptMessage: baseRoute('/encrypt-message'),
  encryptFile: baseRoute('/encrypt-file'),
  decryptMessage: baseRoute('/decrypt-message'),
  decryptFile: baseRoute('/decrypt-file'),
  decryptSharedFile: baseRoute('/decrypt-shared-file'),
  decryptIntakeFiles: baseRoute('/decrypt-intake-files'),
  // teamSettings: baseRoute('/team-settings'),
} as const;
